
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 6C10.664 6 6 9.707 6 14.5c0 2.223 1.273 4.023 2.875 5.5H3v2h9v-1.938l-.469-.28C9.5 18.538 8 16.534 8 14.5 8 11.043 11.586 8 16 8s8 3.043 8 6.5c0 2.035-1.5 4.04-3.531 5.281l-.469.282V22h9v-2h-5.875C24.727 18.523 26 16.723 26 14.5 26 9.707 21.336 6 16 6zM3 24v2h26v-2z"}})])
          )
        }
      }
    